<template>
  <header
    data-cy-region="header"
    class="shadow-custom-2 md:shadow-none bg-white md:bg-page-secondary rounded-b-3xs md:rounded-none relative z-30 pt-8 lg:pb-4"
  >
    <!-- <div class="hidden lg:flex items-center bg-primary-700 px-2 h-12 text-white">
      <div class="container mx-auto flex justify-between">
        <div class="flex space-x-10">
          <button type="button" class="flex items-center" @click="showShoppingGuide = true">
            {{ $t('shoppingGuide') }}
          </button>

          <NavDropdown id="header-owner-support" :title="ownerSupport.title" :links="ownerSupport.links"></NavDropdown>
          <NavDropdown id="header-smart-homes" :title="smartHomes.title" :links="smartHomes.links"></NavDropdown>
          <AppLink to="/about-us" class="flex items-center">
            {{ $t('aboutUs') }}
          </AppLink>
        </div>

        <div class="flex items-center space-x-10">
          <a href="tel:19111" class="flex items-center"> 19111 </a>

          <NavDropdown id="help-center-support" :title="helpCenter.title" :links="helpCenter.links"></NavDropdown>
          <a class="ml-3" :href="switchLocalePath($i18n.locale === 'en' ? 'ar' : 'en')">{{ $t('switchLang') }}</a>
        </div>
      </div>
    </div> -->

    <div class="container mx-auto px-5 lg:px-0 flex justify-between items-center">
      <div class="flex-1 flex items-center md:gap-x-10">
        <button type="button" class="lg:hidden" title="Open Menu" @click="openSideMenu">
          <svg-icon name="menu" class="h-5 w-8 md:w-8 md:h-7" />
        </button>

        <AppLink to="/" class="mx-auto md:mx-0" aria-label="logo">
          <svg-icon name="logo" class="h-[21px] w-[122px] md:w-41 md:h-7" alt="Miraco Logo" />
        </AppLink>
        <CategoryMegaMenu />
      </div>

      <div class="relative flex items-center gap-x-5 justify-between">
        <client-only>
          <svg-icon
            name="search"
            class="h-6 w-6 text-primary-700 cursor-pointer hidden md:block"
            @click="isShown = true"
          />
          <AppLink v-if="!isLoggedIn" to="/login" class="hidden lg:flex lg:ml-auto items-center">
            <svg-icon name="user" class="h-6 w-6 text-primary-700" />
            <!-- <span class="ml-3 text-sm text-primary-700 hidden lg:block">{{ $t('loginOrRegister') }}</span> -->
          </AppLink>
          <ProfileDropdown v-else />
        </client-only>
        <client-only>
          <AppLink
            :to="isLoggedIn ? '/account/wishlist' : '/login'"
            :aria-label="$t('toFavorite')"
            class="lg:ml-auto hidden lg:flex items-center"
            @click="onFavoritesClick"
          >
            <svg-icon name="favorite" width="30" height="26" />
          </AppLink>
        </client-only>

        <AppLink to="/cart" aria-label="Cart" class="ml-auto relative flex items-center justify-center cursor-pointer">
          <svg-icon name="cart" class="w-8 md:w-8 aspect-square" />
          <span
            v-show="count"
            class="bg-coloration-error [ absolute -top-2 -right-2 ] [ h-6 w-6 rounded-lg ] [ text-white text-xs ] [ flex items-center justify-center ]"
          >
            {{ count }}
          </span>
        </AppLink>
      </div>
    </div>
    <SearchDialog class="header-search mt-6 lg:mt-0 w-full lg:w-auto [ lg:hidden order-last ]" />
    <DialogAcCalculator v-model="showShoppingGuide" />
    <Dialog
      v-model="isShown"
      type="default"
      :has-close-button="false"
      class="font-bold text-lg fixed w-[900px] min-h-[200px] h-auto rounded-2xs z-30 px-7 mt-10 bg-transparent"
    >
      <QuickSearch class="mt-6 lg:mt-4 lg:mx-6 flex-1 w-full[ hidden lg:flex ]" />
    </Dialog>
  </header>
</template>

<script setup lang="ts">
import { BottomSheetType, BottomSheetTransitions } from '@robusta/headless-commerce-elements/common';
const { isLoggedIn } = useAuth();
const { items } = useCartAttributes();
const count = computed(() =>
  (items.value || []).reduce((acc: number, item: { quantity: number }) => acc + (item.quantity || 0), 0),
);
const { emit } = useEventBus();
const showShoppingGuide = ref();
const isShown = ref(false);
const { toggleDefinedAlias } = useBottomSheet();

// const { ownerSupport, helpCenter } = useNavLinks();

// const switchLocalePath = useSwitchLocalePath();

const { t: $t } = useI18n({
  useScope: 'local',
});
const { info } = useAlerts();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function openAsideCart() {
  emit('TOGGLE_ASIDE_CART', true);
}

function openSideMenu() {
  // emit('TOGGLE_SIDE_MENU', true);
  toggleDefinedAlias('sideMenu', BottomSheetType.DEFAULT, BottomSheetTransitions.SLIDE_REVERSE);
}

function onFavoritesClick(e: Event) {
  if (!isLoggedIn.value) {
    e.preventDefault();
    info($t('loginToViewFavoritesTitle'), $t('loginToViewFavoritesMessage'));
  }
}
</script>

<style lang="postcss" scoped>
.header-items {
  @apply grid;
  grid-template-columns: 1fr 100px 1fr;

  @screen lg {
    grid-template-columns: 1fr 150px 1fr;
    gap: 30px;
  }

  .header-search {
    grid-column: 1 / span 3;
    @screen lg {
      grid-column: auto;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "loginOrRegister": "Login/Register",
    "greet": "Hello, {name}",
    "contactUs": "Contact us",
    "switchLang": "عربي",
    "logout":  "Logout",
    "notice": "10% OFF & free delivery on online orders",
    "shoppingGuide": "Shopping Guide",
    "forBusiness": "For Business",
    "ownerSupport": {
    "title": "Owner Support",
    "links": {
      "registerAProduct": "Register a Product",
      "bookAnAppointment": "Book an Appointment",
      "warrantyInformation": "Warranty Information",
      "productManuals": "Product Manuals",
      "troubleshooting": "Troubleshooting",
      "contactCustomerSupport": "Contact Customer Support",
      "careers": "Careers",
      "smartHome": "Smart Home"
    }
  },
  "helpCenter": {
    "title": "Help Center",
    "links": {
      "chatSupport": "Chat Support",
      "faqs": "FAQs",
      "contactUs": "Contact Us"
    }
  },
  "smartHomes": {
    "title": "Smart Home",
    "links": {
      "midea": "Midea",
      "carrier": "Carrier",
    }
  },
  "toFavorite": "Go to favorite page",
  "aboutUs": "About Us",
  "loginToViewFavoritesTitle": "Sign in to view your favorites",
  "loginToViewFavoritesMessage": "You need to create an account or log in to see your wishlist"
  },
  "ar": {
    "loginOrRegister": "تسجيل الدخول/ إنشاء حساب",
    "greet": "مرحبا، {name}",
    "contactUs": "تواصل معنا",
    "switchLang": "English",
    "logout":  "تسجيل الخروج",
    "notice": "10٪ خصم على الطلبات الاونلاين",
    "shoppingGuide": "دليل التسوق",
    "forBusiness": "للأقسام التجارية",
    "ownerSupport": {
    "title": "خدمة العملاء",
    "links": {
      "registerAProduct": "سجل المنتج",
      "bookAnAppointment": "حجز موعد",
      "warrantyInformation": "معلومات الضمان",
      "productManuals": "دليل المنتج"
    },
  },
  "helpCenter": {
    "title": "مركز المساعدة",
    "links": {
      "chatSupport": "الدعم عبر الدردشة",
      "faqs": "الأسئلة الشائعة",
      "contactUs": "تواصل معنا"
    }
  },
  "smartHomes": {
    "title": "المنزل الذكي",
    "links": {
      "midea": "ميديا",
      "carrier": "كاريير",
    }
  },
  "toFavorite": "الذهاب إلى صفحة المفضلة",
  "aboutUs": "عن ميراكو",
  "loginToViewFavoritesTitle": "سجل الدخول لعرض المفضلة",
  "loginToViewFavoritesMessage": "يجب عليك إنشاء حساب أو تسجيل الدخول حتى يمكنك رؤية قائمة المفضلة."
  }
}
</i18n>

<style lang="postcss" scoped>
@screen md {
  .header-title {
    display: grid;
    grid-template-columns: 1fr;
  }
}
</style>
